import React from 'react';
import styled from 'styled-components';

interface IProps {
  fill?: string;
  width?: string;
  interact?: boolean | any;
}

const I = styled.i<IProps>`
  & > svg {
    fill: ${props => props.fill || '#000'};
    width: ${props => props.width}px;
    vertical-align: middle;
    cursor: ${props => (props.interact ? 'pointer' : 'default')};
  }
  & > svg:hover {
    fill: ${props => props.fill || '#000'};
    vertical-align: middle;
  }
  &[href='selected'] > svg {
    fill: #fb7901;
  }
`;

export const icons = {
  threeDot: 'threeDot',
  sort: 'sort',
  padlock: 'padlock'
};

export interface CustomIconProps {
  iconName?: string;
  width?: string;
  fill?: string;
  interact?: boolean;
}

export default function CustomIcon(props: CustomIconProps) {
  let icon;
  switch (props.iconName) {
    case icons.sort: {
      icon = (
        <svg
          xmlns="http://www.w3.org/2000/svg"
          width="26"
          height="13"
          viewBox="0 0 26 13"
          style={{ cursor: `move` }}
        >
          <g fill="#9B9B9B" fillRule="nonzero">
            <path d="M.682 1h24.636C25.695 1 26 .778 26 .5c0-.276-.31-.5-.682-.5H.682C.305 0 0 .222 0 .5c0 .276.31.5.682.5zM.682 7h24.636c.377 0 .682-.222.682-.5 0-.276-.31-.5-.682-.5H.682C.305 6 0 6.222 0 6.5c0 .276.31.5.682.5zM.682 13h24.636c.377 0 .682-.222.682-.5 0-.276-.31-.5-.682-.5H.682c-.377 0-.682.222-.682.5 0 .276.31.5.682.5z" />
          </g>
        </svg>
      );
      break;
    }
    case icons.padlock: {
      icon = (
        <svg xmlns="http://www.w3.org/2000/svg" width="68" height="68" viewBox="0 0 68 68">
          <g fill="#9B9B9B" fillRule="nonzero">
            <path d="M58.892 9.078C53.016 3.221 45.195 0 36.898 0c-8.465 0-16.37 3.319-22.274 9.357a.835.835 0 0 0 .014 1.186c.336.32.868.32 1.19-.014 5.582-5.718 13.067-8.856 21.07-8.856C53.114 1.673 66.32 14.823 66.32 31c0 16.176-13.207 29.327-29.423 29.327C20.682 60.327 7.46 47.177 7.46 31v-2.482l4.35 4.337a.83.83 0 0 0 .589.25c.21 0 .433-.083.587-.25a.848.848 0 0 0 0-1.186L7.21 25.91a.855.855 0 0 0-1.19 0L.242 31.67a.848.848 0 0 0 0 1.185.83.83 0 0 0 .588.25c.21 0 .434-.083.588-.25l4.35-4.337V31c0 8.283 3.233 16.065 9.109 21.922C20.752 58.779 28.559 62 36.87 62c8.31 0 16.118-3.221 21.994-9.078C64.74 47.065 68 39.283 68 31c0-8.283-3.232-16.065-9.108-21.922z" />
            <path d="M50.147 28.149H46.35V22.77c0-4.83-3.981-8.771-8.858-8.771-4.891 0-8.858 3.942-8.858 8.77v5.379h-3.782c-.47 0-.853.38-.853.844v16.162c0 .465.384.845.853.845h25.294c.47 0 .853-.38.853-.845V28.993a.851.851 0 0 0-.853-.844zm-19.82-5.378c0-3.9 3.213-7.082 7.152-7.082 3.938 0 7.151 3.182 7.151 7.082v5.378H30.327V22.77zm-4.635 21.54V29.838H49.28v14.473H25.692z" />
          </g>
        </svg>
      );
      break;
    }

    case icons.threeDot: {
      icon = (
        <svg width="25px" height="6px" viewBox="0 0 25 6" version="1.1">
          <g id="Rewards" stroke="none" strokeWidth="1" fillRule="evenodd">
            <g
              id="01-rewards-list"
              transform="translate(-1313.000000, -403.000000)"
              fillRule="nonzero"
            >
              <g id="three-dots-more-indicator" transform="translate(1313.000000, 403.000000)">
                <path
                  d="M3.125,0 C1.40625,0 0,1.35 0,3 C0,4.65 1.40625,6 3.125,6 C4.84375,6 6.25,4.65 6.25,3 C6.25,1.35 4.84375,0 3.125,0 Z M21.875,0 C20.15625,0 18.75,1.35 18.75,3 C18.75,4.65 20.15625,6 21.875,6 C23.59375,6 25,4.65 25,3 C25,1.35 23.59375,0 21.875,0 Z M12.5,0 C10.78125,0 9.375,1.35 9.375,3 C9.375,4.65 10.78125,6 12.5,6 C14.21875,6 15.625,4.65 15.625,3 C15.625,1.35 14.21875,0 12.5,0 Z"
                  id="Shape"
                />
              </g>
            </g>
          </g>
        </svg>
      );
      break;
    }
    default:
      break;
  }
  return (
    <I {...props} className="anticon">
      {icon}
    </I>
  );
}
